import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDetailContainer]'
})
export class DetailContainerDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
